import { Suspense, lazy } from "react";
import { Loader2 } from "lucide-react";
import { useParams } from "react-router-dom";
import PermissionGuard from "@/shared/components/PermissionGuard";
import { useInstitutionAccess } from "@/shared/hooks/useInstitutionAccess";

const FormularioInstituicao = lazy(() => import("@/interno/instituicoes/paginas/FormularioInstituicao"));

const LazyFallback = (
  <div className="flex items-center justify-center py-20">
    <Loader2 className="h-8 w-8 animate-spin text-primary" />
  </div>
);

/**
 * Permite que usuários institution_external editem a instituição do portal
 * quando o id da rota for o da instituição permitida. Outros usuários exigem permissão instituicoes → alterar.
 */
const InstitutionEditRouteGuard = () => {
  const { id } = useParams<{ id: string }>();
  const { isExternalUser, institutionId, loading: accessLoading } = useInstitutionAccess();

  if (accessLoading) {
    return (
      <div className="flex items-center justify-center py-20">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (isExternalUser && institutionId === id) {
    return <Suspense fallback={LazyFallback}><FormularioInstituicao /></Suspense>;
  }

  return (
    <PermissionGuard module="instituicoes" operation="alterar">
      <Suspense fallback={LazyFallback}><FormularioInstituicao /></Suspense>
    </PermissionGuard>
  );
};

export default InstitutionEditRouteGuard;
